export default __webpack_public_path__ + "static/media/photo--lg--127.f6f22cf7.jpg";